// extracted by mini-css-extract-plugin
export default {"toggleContainer":"x7-z","toggleBtn":"y7-z","toggleLabel":"z7-z","tooltipContainer":"A7-z","tooltipWrapper":"B7-z","tooltipContentTop":"C7-z"};